import apiClient, { createFormData } from './api';
import { ConversionTask } from '../types/conversion.types';
import { getUrlWithToken } from '../utils/urlUtils';

/**
 * 获取所有支持的转换操作列表
 */
export async function getOperations(): Promise<string[]> {
    const response = await apiClient.get<{ operations: string[] }>('/api/v1/convert/operations');
    return response.data.operations;
}

/**
 * 创建转换任务
 */
export async function createConversionTask(
    files: File | File[],
    operation: string,
    options?: Record<string, unknown>
): Promise<ConversionTask> {
    const fileArray = Array.isArray(files) ? files : [files];
    const formData = createFormData({
        files: fileArray,
        operation: operation,
        options: JSON.stringify(options || {})
    });

    const response = await apiClient.post<ConversionTask>('/api/v1/convert', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data;
}

/**
 * 获取任务详情
 */
export async function getConversionTask(taskId: string): Promise<ConversionTask> {
    const response = await apiClient.get<ConversionTask>(`/api/v1/convert/tasks/${taskId}`);
    return response.data;
}

/**
 * 删除任务及文件
 */
export async function deleteConversionTask(taskId: string): Promise<void> {
    await apiClient.delete(`/api/v1/convert/tasks/${taskId}`);
}

/**
 * 生成下载 URL
 */
export function getDownloadUrl(taskId: string): string {
    const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
    const token = localStorage.getItem('auth_token');
    return getUrlWithToken(`${baseUrl}/api/v1/convert/tasks/${taskId}/download`, token);
}

/**
 * 获取转换任务列表
 */
export async function listConversionTasks(params: { page?: number; pageSize?: number; status?: string; operation?: string } = {}) {
    const { page = 1, pageSize = 20, status, operation } = params;
    let url = `/api/v1/convert/tasks?page=${page}&page_size=${pageSize}`;
    if (status) {
        url += `&status=${status}`;
    }
    if (operation) {
        url += `&operation=${operation}`;
    }
    const response = await apiClient.get<{
        items: ConversionTask[];
        total: number;
        page: number;
        page_size: number;
    }>(url);
    return response.data;
}
